import { render, staticRenderFns } from "./SurveyTemplateEditor.vue?vue&type=template&id=4c8fa8ec&scoped=true"
import script from "./SurveyTemplateEditor.vue?vue&type=script&lang=js"
export * from "./SurveyTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./SurveyTemplateEditor.vue?vue&type=style&index=0&id=4c8fa8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fa8ec",
  null
  
)

export default component.exports